/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HotelComparisonHighlight
 */
export interface HotelComparisonHighlight {
    /**
     * The Vervotech property ID.
     * @type {number}
     * @memberof HotelComparisonHighlight
     */
    vervotechPropertyId: number;
    /**
     * The hotel name.
     * @type {string}
     * @memberof HotelComparisonHighlight
     */
    propertyName: string;
    /**
     * 1-2 sentence personalized highlight for this hotel.
     * @type {string}
     * @memberof HotelComparisonHighlight
     */
    highlight: string;
    /**
     * Short label, e.g. 'Best points value', 'Matches your Marriott loyalty'.
     * @type {string}
     * @memberof HotelComparisonHighlight
     */
    bestFor: string;
}

/**
 * Check if a given object implements the HotelComparisonHighlight interface.
 */
export function instanceOfHotelComparisonHighlight(value: object): value is HotelComparisonHighlight {
    if (!('vervotechPropertyId' in value) || value['vervotechPropertyId'] === undefined) return false;
    if (!('propertyName' in value) || value['propertyName'] === undefined) return false;
    if (!('highlight' in value) || value['highlight'] === undefined) return false;
    if (!('bestFor' in value) || value['bestFor'] === undefined) return false;
    return true;
}

export function HotelComparisonHighlightFromJSON(json: any): HotelComparisonHighlight {
    return HotelComparisonHighlightFromJSONTyped(json, false);
}

export function HotelComparisonHighlightFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelComparisonHighlight {
    if (json == null) {
        return json;
    }
    return {
        
        'vervotechPropertyId': json['vervotech_property_id'],
        'propertyName': json['property_name'],
        'highlight': json['highlight'],
        'bestFor': json['best_for'],
    };
}

export function HotelComparisonHighlightToJSON(json: any): HotelComparisonHighlight {
    return HotelComparisonHighlightToJSONTyped(json, false);
}

export function HotelComparisonHighlightToJSONTyped(value?: HotelComparisonHighlight | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vervotech_property_id': value['vervotechPropertyId'],
        'property_name': value['propertyName'],
        'highlight': value['highlight'],
        'best_for': value['bestFor'],
    };
}

